import { Link, useParams } from 'react-router-dom';
import { Markdown } from '../components/Markdown';
import { guideBySlug, guideEntries } from '../guide/manifest';
import { useMemo } from 'react';

export function GuidePage() {
  const { slug = 'overview' } = useParams();
  const entry = guideBySlug.get(slug);

  const grouped = useMemo(() => {
    const out = new Map<string, typeof guideEntries>();
    for (const e of guideEntries) {
      if (!out.has(e.group)) out.set(e.group, []);
      out.get(e.group)!.push(e);
    }
    return out;
  }, []);

  if (!entry) {
    return (
      <div className="guide-shell">
        <div className="guide-content">
          <h1>Page not found</h1>
          <p>That guide chapter doesn’t exist (yet). <Link to="/guide/overview">Back to the overview →</Link></p>
        </div>
      </div>
    );
  }

  const idx = guideEntries.findIndex((e) => e.slug === entry.slug);
  const prev = idx > 0 ? guideEntries[idx - 1] : null;
  const next = idx < guideEntries.length - 1 ? guideEntries[idx + 1] : null;

  return (
    <div className="guide-shell">
      <aside className="guide-sidebar">
        <div className="guide-sidebar__inner">
          {[...grouped.entries()].map(([group, items]) => (
            <section key={group}>
              <h3>{group}</h3>
              <ul>
                {items.map((item) => (
                  <li key={item.slug}>
                    <Link
                      to={`/guide/${item.slug}`}
                      className={item.slug === entry.slug ? 'is-active' : undefined}
                    >
                      {item.title}
                    </Link>
                  </li>
                ))}
              </ul>
            </section>
          ))}
        </div>
      </aside>
      <article className="guide-content">
        <Markdown source={entry.body} />
        <nav className="guide-nav">
          {prev ? (
            <Link className="guide-nav__prev" to={`/guide/${prev.slug}`}>
              <span>← Previous</span>
              <strong>{prev.title}</strong>
            </Link>
          ) : <span />}
          {next ? (
            <Link className="guide-nav__next" to={`/guide/${next.slug}`}>
              <span>Next →</span>
              <strong>{next.title}</strong>
            </Link>
          ) : <span />}
        </nav>
      </article>
    </div>
  );
}
